"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function cs(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.8861 7.21875C14.7258 7.3545 15.6183 8.4525 15.6183 8.65125C15.6183 8.7915 15.5846 9.0975 15.5846 9.285C15.5846 9.41025 15.6296 9.6105 15.7196 9.885C15.6971 10.0725 15.5733 10.167 15.3476 10.167C15.0101 10.167 15.1046 9.78825 14.6036 9.03825C14.0636 8.2305 13.5176 8.061 12.8831 8.02575C12.8958 9.74775 12.9431 14.4877 12.9468 16.1182C14.6381 15.8722 15.5771 14.6093 15.8208 14.6093C15.9558 14.6093 16.1253 14.7142 16.1253 14.9618C16.1253 15.483 14.7888 16.662 12.9213 16.8953C12.7818 18.417 12.0618 20.25 10.2753 20.25C9.43007 20.25 8.71982 19.5975 8.71982 18.84C8.71982 18.3465 9.09182 18.135 9.43007 18.135C9.76757 18.135 10.1058 18.3818 10.1058 18.84C10.1058 19.1453 10.0046 19.3575 9.80207 19.4745C10.0046 19.6155 10.2071 19.686 10.4103 19.686C11.0868 19.686 11.5953 18.462 11.6823 16.8885C9.71132 16.572 7.87457 14.694 7.87457 11.9648C7.87457 8.895 9.78707 7.5675 11.6628 7.27125C11.7003 5.89125 12.4211 3.78375 14.2653 3.75C15.3806 3.75 15.8538 4.6665 15.8538 5.16C15.8538 5.6535 15.4991 5.865 15.1443 5.865C14.7888 5.865 14.4341 5.583 14.4341 5.16C14.4341 4.878 14.5466 4.6785 14.7716 4.56075C14.6141 4.41975 14.4116 4.34925 14.1641 4.34925C13.2258 4.34925 12.9311 6.32775 12.8853 7.21875H12.8861ZM11.6958 16.0597C11.6928 14.2343 11.6696 10.0275 11.6636 8.09475C9.93257 8.52 9.36332 10.5795 9.36332 11.9648C9.36332 14.1608 10.4013 15.669 11.6958 16.0597Z", fill: color }));
}
exports["default"] = cs;
//# sourceMappingURL=cs.js.map